import React from "react";
import { useTranslation } from "react-i18next";
import cx from "clsx";
import './../../scss/ModalWindow/ModalWindow.scss';
export const Modal = ({
  id,
  showModal,
  children,
  customClass,
  closeModalEventListener,
  restrictCloseModalOnBackdrop
}) => {

  return (
    <div
      id={id}
      className={cx("modal-wrapper", {
        active: showModal
      })}
    >
      <div
        className={cx("modal", {
          active: showModal,
          [`${customClass}`]: customClass
        })}
      >
        {children}
      </div>

      {showModal && (
        <div
          className={cx("modal-backdrop", {
            active: showModal
          })}
          onClick={
            !restrictCloseModalOnBackdrop ? closeModalEventListener : null
          }
        ></div>
      )}
    </div>
  );
};

export const ModalHeader = ({ children }) => {
  return <div className="modal-header">{children}</div>;
};

export const ModalMainContent = ({ children }) => {
  return <div className="modal-main">{children}</div>;
};

export const ModalFooter = ({ children }) => {
  return <div className="modal-footer">{children}</div>;
};

export const ModalCloseBtn = ({ children, closeModalEventListener }) => {
  // const onClickEventListener = (e) => {
  //   closeModalEventListener();
  // }
  const { t } = useTranslation();
  return (
    <span onClick={closeModalEventListener} className="modal-close-btn">
      {t("header.loginMenu.close")}
    </span>
  );
};
